import {FC, ChangeEvent, useRef, useEffect} from 'react'
import {Spinner} from 'react-bootstrap'
import {ArrowRightShort} from 'react-bootstrap-icons'
import {authStyles} from '../layout/authStyles.ts'
import useIsMobile from '../../hooks/useIsMobile'

interface AuthEmailInputProps {
    value: string
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    onBlur?: () => void
    placeholder: string
    testId?: string
    autoComplete?: string
    showSubmitButton?: boolean
    submitDisabled?: boolean
    isLoading?: boolean
    submitAriaLabel?: string
    submitButtonTestId?: string
    autoFocusOnDesktop?: boolean
}

const AuthEmailInput: FC<AuthEmailInputProps> = ({
                                                     value,
                                                     onChange,
                                                     onBlur,
                                                     placeholder,
                                                     testId = 'email-input',
                                                     autoComplete = 'email',
                                                     showSubmitButton = false,
                                                     submitDisabled = false,
                                                     isLoading = false,
                                                     submitAriaLabel = 'Continue',
                                                     submitButtonTestId,
                                                     autoFocusOnDesktop = false
                                                 }) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const isMobile = useIsMobile()

    useEffect(() => {
        if (autoFocusOnDesktop && !isMobile && inputRef.current) {
            inputRef.current.focus()
        }
    }, [autoFocusOnDesktop, isMobile])

    return (
        <div className={authStyles.inputWrapper}>
            <input
                ref={inputRef}
                type="email"
                name="email"
                className={authStyles.pillInput}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                autoComplete={autoComplete}
                data-testid={testId}
                required
            />
            {showSubmitButton && (
                <button
                    type="submit"
                    className={authStyles.circularSubmit}
                    disabled={submitDisabled || isLoading}
                    aria-label={submitAriaLabel}
                    data-testid={submitButtonTestId}
                >
                    {isLoading ? (
                        <Spinner size="sm" animation="border"/>
                    ) : (
                        <ArrowRightShort/>
                    )}
                </button>
            )}
        </div>
    )
}

export default AuthEmailInput
